<template>
  <div class="pictrue_main_box wh100 pr">
    <HnContent :hasData='hasData'>
      <template slot="left">
        <LocalMenu :menuDevType='menuDevType' @changeDev='devChangeFun'></LocalMenu>

<!--        <div class="search_box pr">-->
<!--          <el-autocomplete-->
<!--            class="inline-input"-->
<!--            v-model="searchVal"-->
<!--            clearable-->
<!--            ref="cautocomplete"-->
<!--            :fetch-suggestions="querySearch"-->
<!--            placeholder="请输入关键字"-->
<!--            :trigger-on-focus="false"-->
<!--            @select="handleSearch"-->
<!--            @clear="clearSearch"-->
<!--          >-->
<!--            <i slot="prefix" class="el-input__icon el-icon-search"></i>-->
<!--            <template slot-scope="{ item }">-->
<!--              <div class="auto_select_box">-->
<!--                <span :class="['iconfont', item.iconCls || 'icon-tongdaozhuangtai', 'baseColor','autoIcon']"></span>-->
<!--                <div class="info_box">-->
<!--                  <p>{{ item.value }}</p>-->
<!--                  <p>{{ item.devCode }}</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </template>-->
<!--          </el-autocomplete>-->
<!--          <el-tooltip effect="dark" :content="groupContent" placement="top">-->
<!--            <span :class="['active-cp', 'grounpIcon', 'iconfont', groupIcon]" @click="groupChange"></span>-->
<!--          </el-tooltip>-->

<!--        </div>-->

<!--        <template v-if="devList.length">-->
<!--          <ul class="site-menu wh100 boxScroll">-->
<!--            <li v-for="item in devList" :key="item.id">-->

<!--            </li>-->
<!--          </ul>-->
<!--        </template>-->
<!--        <template v-else>-->
<!--          <div class="mt100">-->
<!--            <hn-emptyData :text= "emptyText"  size= '160px' setType= 'col'></hn-emptyData>-->
<!--          </div>-->

<!--        </template>-->
      </template>

      <template slot="right">
        <div class="d-flex align-items-center wh100">
          <div class="map_box boxBg" v-if="devListLoaded">
            <mapBox :list="devList" ref="mapBoxRef" />
          </div>

          <div class="detail">
            <div class="w100" style="height: 72%">
              <box title="垃圾站详情">
                <div class="d-flex flex-column" style="box-sizing: border-box; padding: 17px 20px 20px 20px">
                  <!--                  基础信息-->
                  <div class="d-flex">
<!--                    <div style="width: 200px; height: 120px; background-color: #1e2c36" class="empty_box_min" v-if="true">-->
<!--                      <img :src="noDataImg" alt="" style="width: 90px; height: 90px" />-->
<!--                      <p class="font-12">暂无图片</p>-->
<!--                    </div>-->

                    <div class="d-flex flex-column" style="gap: 5px">
                      <div class="font-14">点位名称：<span class="text-00ffc5">{{ devInfo.name || '-' }}</span></div>
                      <div class="font-14">
                        负责人：
                        <span class="text-00ffc5"
                              v-if="devInfo && devInfo.pointInfo && devInfo.pointInfo.areaInfo && devInfo.pointInfo.areaInfo.principal && devInfo.pointInfo.areaInfo.principal.realName">{{ devInfo.pointInfo.areaInfo.principal.realName || '-' }}</span>
                        <span v-else>-</span>
                      </div>
                      <div class="font-14">
                        联系方式：
                        <span class="text-00ffc5" v-if="devInfo && devInfo.pointInfo && devInfo.pointInfo.areaInfo && devInfo.pointInfo.areaInfo.principal && devInfo.pointInfo.areaInfo.principal.mobile">{{ devInfo.pointInfo.areaInfo.principal.mobile || '' }}</span>
                        <span v-else>-</span>
                      </div>
                    </div>
                  </div>

                  <!--                  简介-->
                  <div class="font-14 d-flex" style="margin-top: 5px">
                    <div style="width: 45px; flex-shrink: 0">
                      简介：
                    </div>
                    <div class="text-00ffc5 w100"
                         v-if="devInfo && devInfo.pointInfo && devInfo.pointInfo.areaInfo && devInfo.pointInfo.areaInfo.intro"
                         style="height: 104px; background: #2C3E4B; box-sizing: border-box; padding: 8px 10px 10px 10px; margin-top: 4px; overflow: auto">
                      <div v-html="devInfo.pointInfo.areaInfo.intro" style="overflow: auto"></div>
                    </div>
                    <div class="text-00ffc5 w100"
                         v-else
                         style="height: 104px; background: #2C3E4B; box-sizing: border-box; padding: 8px 10px 10px 10px; margin-top: 4px; overflow: auto">
                      <div v-html="emptyHtml" style="overflow: auto"></div>
                    </div>
                  </div>

                  <!--                  告警信息-->
                  <div class="font-14 text-write" style="margin-top: 17px">告警信息</div>
                  <div class="alarm">
                    <i class="iconfont icon-gaojing21" style="font-size: 15px; color: #FFA800"></i>
                    <div class="text-FFA800 font-12 ml-6" v-if="devAlarm && devAlarm.alarmType">{{ $formatter(devAlarm.alarmType,'alarmType') }}</div>
                    <div style="height: 12px; width: 0; border: 1px solid rgba(128,128,128,0.6)" class="ml-10"></div>
                    <div class="font-12 ml-10 single-ellipsis" style="max-width: 70%" v-if="devAlarm">{{ devAlarm.alarmContent }}</div>
                    <div class="font-12 ml-10 single-ellipsis" style="max-width: 70%" v-else>暂无告警</div>
                  </div>

                  <!--                  垃圾箱-->
                  <div class="font-14 text-write mt-10 mb-10 d-flex align-items-center">
                    <div>
                      垃圾箱
                    </div>
                    <div class="d-flex align-items-center">
                      <i class="iconfont icon-xinhao ml-8" style="font-size: 12px; color: #00B38A"></i>
                      <div class="text-00ffc5 font-12 ml-6">{{ $formatter(devInfo.onlineStatus, 'onlineStatus') }}</div>
                    </div>
                  </div>

                  <vue-seamless-scroll
                    :data="devInfo.boxs"
                    :class-option="rollOption"
                    class="nowData_content_box"
                    :key="timer"
                    @click.native="handleContainerClick"
                  >
                    <div class="boxItem" v-for="item in devInfo.boxs">
                      <div class="itemHead">
                        <i class="iconfont icon-lajitong ml-10" style="font-size: 18px; color: #00B38A"></i>
                        <div class="font-12 ml-4 single-ellipsis" style="max-width: 210px">{{ '垃圾箱' + item.doorNo }}</div>
                        <!--                      <div class="font-12 br10 ml-8" style="background: #00B38A; box-sizing: border-box; padding: 0 4px">农业废弃垃圾</div>-->
                        <div style="margin: 0 12px 0 auto; cursor: pointer"
                             class="font-12 text-00ffc5"
                             data-action="deliver"
                             :data-item="JSON.stringify(item)">查看投递详情></div>
                      </div>
                      <div class="itemBody">
                        <div class="d-flex flex-column align-items-center justify-content-center" style="gap: 5px">
                          <div class="font-16 text-00ffc5">{{ item.isDoorOpen ? '打开' : '关闭' }}<span class="font-12"></span></div>
                          <div class="font-12">{{ '开门状态' }}</div>
                        </div>
                        <div class="d-flex flex-column align-items-center justify-content-center" style="gap: 5px">
                          <div class="font-16" :class="item.isFull ? 'text-FFA800' : 'text-00ffc5'">{{ item.isFull ? '满溢' : '正常' }}<span class="font-12"></span></div>
                          <div class="font-12">{{ '满溢状态' }}</div>
                        </div>
                        <div class="d-flex flex-column align-items-center justify-content-center" style="gap: 5px">
                          <div class="font-16" :class="item.hasOverTemperatureAlarm ? 'text-FFA800' : 'text-00ffc5'">{{ item.temperature + '℃' }}<span class="font-12"></span></div>
                          <div class="font-12">{{ '箱体温度' }}</div>
                        </div>
                        <div class="d-flex flex-column align-items-center justify-content-center" style="gap: 5px">
                          <div class="font-16" :class="item.isFull ? 'text-FFA800' : 'text-00ffc5'">{{ item.currentWeightText }}<span class="font-12"></span></div>
                          <div class="font-12">{{ '当前重量' }}</div>
                        </div>
                      </div>
                    </div>
                  </vue-seamless-scroll>
                </div>
              </box>
            </div>

            <div class="w100 mt10" style="height: 27%">
              <box title="告警信息">
                <div slot="tools"
                     class="text-00ffc5 font-12 mr-10"
                     style="margin-top: 6px; cursor: pointer"
                     @click="openAlarmList">
                  查看更多>
                </div>

                <div v-if="alarmList.length" class="d-flex flex-column" style="box-sizing: border-box; padding: 8px 20px 20px 20px">
                  <div class="alarm2" v-for="item in alarmList">
                    <i class="iconfont icon-gaojing21" style="font-size: 15px; color: #FFA800"></i>
                    <div class="text-FFA800 font-12 ml-6" style="flex-shrink: 0" v-if="item.alarmType">{{ $formatter(item.alarmType,'alarmType') }}</div>
                    <div style="height: 12px; width: 0; border: 1px solid rgba(128,128,128,0.6)" class="ml-10"></div>
                    <div v-if="item.alarmContent" class="font-12 ml-10 single-ellipsis" style="max-width: 50%; margin-right: 10px" :title="item.alarmContent">{{ item.alarmContent }}</div>
                    <div style="margin: 0 20px 0 auto; flex-shrink: 0" class="font-12">{{ item.alarmTime }}</div>
                  </div>
                </div>

                <div v-else>
                  <hn-emptyData :text="emptyText"  size= '130px' setType= 'col'></hn-emptyData>
                </div>

              </box>
            </div>

          </div>
        </div>
      </template>
    </HnContent>
  </div>
</template>

<script>
import menuFun from '@/mixins/menuFun'
import mapBox from './components/mapBox'
import box from "./components/box";
import alarmList from "./components/alarmList.vue"
import deliverDetail from "./components/deliverDetail.vue"
import LocalMenu from "./components/localMenu/index.vue"
import {
  GetSmartGarbageRoomBoxAlarmPageList,
  GetSmartGarbageRoomInfo,
  GetSmartGarbageRoomPageList
} from "@/api/apiModel/web";
export default {
  mixins: [menuFun],
  components: {
    mapBox,
    box,
    LocalMenu
  },
  data(){

    return {
      emptyHtml: '-',
      rollOption:{
        direction: 1,
        step: 0.6, // 数值越大速度滚动越快
        limitMoveNum: 3,
      },
      timer: (new Date()).getTime(),
      searchVal: null,
      devListLoaded: false, // 添加加载状态
      navMenus: [],
      devList: [],
      devInfo: {},
      devAlarm: {},
      alarmList: [],
      menuDevType: ['回收'],
      noDataImg: require("@/assets/imgs/noData/no_min_data.png"),
      list: [
        { name: '开门状态', value: '关闭', unit: '' },
        { name: '满溢状态', value: '正常', unit: '' },
        { name: '箱体温度', value: '36.2', unit: '℃' },
        { name: '当前重量', value: '3600', unit: 'g' },
      ],
      emptyText: '暂无数据',
    }
  },
  computed:{

  },
  methods:{
    handleContainerClick(event) {
      // 事件代理处理
      const target = event.target;

      // 处理查看投递详情点击
      if (target.classList.contains('text-00ffc5') && target.textContent.includes('查看投递详情')) {
        const itemData = target.getAttribute('data-item');
        if (itemData) {
          try {
            const item = JSON.parse(itemData);
            this.openDeliver(item);
          } catch (e) {
            console.error('解析item数据失败:', e);
          }
        }
      }

      // 可以添加其他子元素的事件处理
    },
    changeFun() {

    },
    async devChangeFun(data) {
      // data[0] id    data[1] code
      if (data[0]){
        // 设备详情
        await GetSmartGarbageRoomInfo({ devId: data[0] }).then((res) => {
          if (res){
            this.devInfo = res
            console.log('获取获取', this.devInfo.boxs)
            const centerPoint = [res.lng, res.lat];
            this.$refs.mapBoxRef.setCenter(centerPoint);
          }
        })

        // 告警
        this.alarmList = []
        this.devAlarm = {}
        await GetSmartGarbageRoomBoxAlarmPageList({ devCode: data[1], pageSize: 5, pageIndex: 1 }).then((res) => {
          if (res){
            this.alarmList = res.list
            this.devAlarm = res.list[0]
          }
        })
      }
    },
    // 获取5条告警信息
    async getAllAlarm() {
      await GetSmartGarbageRoomBoxAlarmPageList({ pageSize: 5, pageIndex: 1 }).then((res) => {
        if (res){
          this.alarmList = res.list
        }
      })
    },
    // 获取垃圾站详情
    async getDevInfo() {

    },
    // 查看更多告警信息
    openAlarmList() {
      this.showDialog(
        alarmList,
        { props: { obj: { info: this.devList, devSelect: this.devInfo } } },
        {
          width: "1200px",
          title: "告警信息",
          dialog: {
            isBut: false,
            isCenter: true,
          },
        }
      );
    },
    // 查看投递详情
    openDeliver(item) {
      // 原有的打开投递详情方法
      this.showDialog(
        deliverDetail,
        { props: { info: item } },
        {
          width: "900px",
          title: "投递详情",
          dialog: {
            isBut: false,
            isCenter: true,
          },
        }
      );
    },
    // 获取回收站列表
    async getDevList() {
      await GetSmartGarbageRoomPageList({ searchName: this.searchVal, pageSize: 999, pageIndex: 1 }).then((res) => {
        if (res){
          this.devList = res.list
          this.devListLoaded = true // 设置加载完成状态
        }
      })
    },
  },
  created () {
    this.getDevList()
    // this.getAllAlarm()
  },
}
</script>

<style lang="scss" scoped>
.map_box{
  height: 100%;
  //width: 100%;
  flex: 1;
  //outline: 1px red solid;
}
.detail{
  height: 100%;
  width: 29.5%;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.text-00ffc5{
  color: #00FFC5;
}
.text-FFA800{
  color: #FFA800;
}
.empty_box_min {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  & > p {
    margin-top: 0px;
  }
}
.alarm{
  width: 462px;
  height: 31px;
  margin-top: 10px;
  background: url('../../../assets/imgs/recycle/alarmBg.png') no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.alarm2{
  width: 462px;
  height: 30px;
  margin-top: 3px;
  background: url('../../../assets/imgs/recycle/alarmBg.png') no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.boxItem{
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  margin: 0 0 10px 0;
  .itemHead{
    height: 30px;
    background: #2C3E4B;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .itemBody{
    height: 70px;
    background: rgba(44, 62, 75, 0.5);
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
}
.ellipsis2{
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.nowData_content_box{
  //outline: 1px red solid;
  //width: calc(100% - 40px);
  //padding: 20px 0;
  //margin: 0 20px;
  box-sizing: border-box;
  //border-radius: 8px;
  overflow: hidden;
  height: 220px;
}
</style>